export default "__VITE_ASSET__DxsCzOi1__"